import { countRejectedRequests, RejectedRequestBadgedLabel } from '../Status/RejectedRequestBadgedLabel'
import { AssignmentRequestActions } from '../AssignmentRequests/ButtonsAssignmentRequestActions'
import { stdDateHelper } from '../../Utils/DateUtils'
import { RequestReferenceItem } from './ReferenceItem'
import { IRequestTableData } from './RequestsTable'
import { Link } from 'react-router-dom'
import { Darwin } from '@nic/nic-api/types'
import { IReferenceContact } from '@nic/nic-api/types/Darwin/types'
import { Registrar, UserName } from '@nic/ui-antd'
import { Typography } from 'antd'
import StatusView from '../Status/StatusView'
import { isRegistryUserDarwinAdmin } from '../User/utils'

const { Text } = Typography

export const requestsTableRegistry = (realm: any, data: any, keycloak: any) => {

  // Creiamo una mappa per memorizzare i dati già calcolati per ogni riga
  const rowCache = new Map<number, any>()

  const getRow = (id: number) => {
    if (!rowCache.has(id)) {
      rowCache.set(id, data?.find((d: any) => d.id === id))
    }
    return rowCache.get(id)
  }

  return {
    id: (id: number) => <Link to={`/${realm}/requests/${id}`}>{id}</Link>,
    registrarId: (id: number) => (
      <Registrar
        id={id}
        render={(d: any) => <div style={{ whiteSpace: 'nowrap' }}>{d.name}</div>}
      />
    ),
    userId: (id: number) => <UserName userId={id} />,
    status: (status: Darwin.RequestStatus) => <StatusView status={status} />,
    extra: (status: Darwin.RequestStatus, record: IRequestTableData) => {
      if (['pending', 'registrarUpdated'].includes(status)) {
        const currentRow = getRow(record.id)
        return (
          <RejectedRequestBadgedLabel count={countRejectedRequests(currentRow?.events as any)} />
        )
      }
      return <></>
    },
    referenceContact: (referenceContact: IReferenceContact) =>
      referenceContact && (
        <div style={{ minWidth: '200px' }}>{RequestReferenceItem(referenceContact)}</div>
      ),
    action: (text: any, record: IRequestTableData) => {
      const currentRow = getRow(record.id)
      if (currentRow?.status === 'pending' || currentRow?.status === 'registrarUpdated') {
        const isRegistryAssignedUser = currentRow?.registryUser?.id === keycloak?.tokenParsed?.userId
        const isRegistryAssigned = !!currentRow?.registryUser?.id
        return (
          <div style={{ float: 'right' }}>
            <AssignmentRequestActions
              disableAssignToMeButton={
                isRegistryAssignedUser || (isRegistryAssigned && !isRegistryUserDarwinAdmin(keycloak))
              }
              disableReleaseButton={!isRegistryAssignedUser}
              disableAssignToUserButton={!isRegistryUserDarwinAdmin(keycloak)}
              requestId={record.id}
              flash={!isRegistryAssignedUser}
            />
          </div>
        )
      }
      return <></>
    },
    created: (created: string) => <span>{stdDateHelper(created)}</span>,
    domains: (value: any) => <div style={{ textAlign: 'left' }}>{value}</div>,
    registrarUser: (value: Darwin.RegistrarUser) => (
      <div style={{ textAlign: 'center', fontSize: '0.8rem' }}>
        {value ? (
          <Text strong style={{ color: '#B2B2B2' }}>{value.username}</Text>
        ) : (
          <></>
        )}
      </div>
    ),
    registryUser: (value: Darwin.RegistrarUser, record: IRequestTableData) => {
      const currentRow = getRow(record.id)
      const isRegistryAssignedUser = currentRow?.registryUser?.id === keycloak?.tokenParsed?.userId
      return (
        <div style={{ textAlign: 'center', fontSize: '0.8rem' }}>
          {value ? (
            <Text strong style={{ color: isRegistryAssignedUser ? '#000000' : '#B2B2B2' }}>
              {value.username}
            </Text>
          ) : (
            <></>
          )}
        </div>
      )
    },
    contacts: (value: number) => <div style={{ textAlign: 'center' }}>{value}</div>,
  }
}
